import { useRef, useCallback, useEffect, useState } from 'react'
import { Transition } from 'react-transition-group'

import { useEventListener } from '@/hooks'
import { Container, InnerContainer, Item } from './Styles'

interface ItemProps {
  children: JSX.Element | JSX.Element[]
}
interface ActionBarProps {
  children: (state?: string) => JSX.Element
  active: boolean
  containerSelector: string
  bottomDistance?: number
}

const ActionBar = ({
  children,
  active,
  containerSelector,
  bottomDistance,
}: ActionBarProps) => {
  const ref = useRef<HTMLDivElement>(null)
  const [marginLeft, setMarginLeft] = useState(0)
  const containerWidth = (
    document.querySelector(containerSelector) as HTMLDivElement
  )?.offsetWidth

  const elementWidth = ref?.current?.offsetWidth

  const calcMarginLeft = useCallback(() => {
    if (containerWidth && elementWidth) {
      setMarginLeft((containerWidth - elementWidth) / 2)
    }
  }, [containerWidth, elementWidth])

  useEffect(() => {
    calcMarginLeft()
  }, [calcMarginLeft])

  useEventListener('resize', () => calcMarginLeft())

  const defaultStyle = {
    transition: `all 300ms ease`,
  }
  const transitionStyles = {
    entering: { transform: 'translate(0, calc(100% + 40px))' },
    entered: { transform: 'translate(0, 0)' },
    exiting: { transform: 'translate(0, calc(100% + 40px))' },
    exited: { transform: 'translate(0, calc(100% + 40px))' },
    unmounted: {},
  }

  return (
    <Transition
      appear
      exit
      timeout={{ appear: 0, enter: 500, exit: 300 }}
      in={active}>
      {state => (
        <Container
          bottomDistance={bottomDistance}
          ref={ref}
          style={{
            ...defaultStyle,
            ...transitionStyles[state],
            marginLeft: !isNaN(marginLeft) ? marginLeft : undefined,
          }}
          onMouseDown={e => e.stopPropagation()}
          onMouseUp={e => e.stopPropagation()}
          onClick={e => e.stopPropagation()}>
          <InnerContainer>{children(state)}</InnerContainer>
        </Container>
      )}
    </Transition>
  )
}

ActionBar.Item = ({ children, ...rest }: ItemProps) => (
  <Item {...rest}>{children}</Item>
)

export default ActionBar
